import script from "./multipleChoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./multipleChoice.vue?vue&type=script&lang=ts&setup=true"

import "./multipleChoice.vue?vue&type=style&index=0&id=cfd15002&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfd15002"]])

export default __exports__